import { useActions } from '../../../hooks/useActions';
import { CardFormatType, CardSizeType, CardType } from '../../../types/decks';
import { CollectionCard } from './cards/CollectionCard/CollectionCard';
import { ContentCard } from './cards/ContentCard/ContentCard';
import { LiveCard } from './cards/LiveCard/LiveCard';
import { VodCard } from './cards/VodCard/VodCard';

export function Card({
  card,
  cardSize,
  cardFormat,
  actions,
}: {
  card: CardType;
  cardSize: CardSizeType;
  cardFormat: CardFormatType;
  actions: ReturnType<typeof useActions>;
}): React.ReactNode {
  switch (card.__typename) {
    case 'VodCard':
      return (
        <VodCard
          key={card.id}
          card={card}
          cardSize={cardSize}
          cardFormat={cardFormat}
          actions={actions}
        />
      );
    case 'LiveCard':
      return (
        <LiveCard
          key={card.id}
          card={card}
          cardSize={cardSize}
          cardFormat={cardFormat}
          actions={actions}
        />
      );
    case 'ContentCard':
      return (
        <ContentCard
          key={card.id}
          card={card}
          cardSize={cardSize}
          cardFormat={cardFormat}
          actions={actions}
        />
      );
    case 'CollectionCard':
      return (
        <CollectionCard key={card.id} card={card} cardSize={cardSize} cardFormat={cardFormat} />
      );
    default:
      return null;
  }
}

export function CardSize({
  size,
  children,
}: {
  size: CardSizeType;
  children: React.ReactNode;
}): React.ReactNode {
  let cssString = '';

  switch (size) {
    case 'XLARGE':
      cssString = 'w-col-12 h-full flex-shrink-0 select-none relative group';
      break;
    case 'LARGE':
      cssString =
        'w-col-12 768:w-col-8 1200:w-col-6 h-full flex-shrink-0 select-none relative group';
      break;
    case 'MEDIUM':
      cssString =
        'w-col-9 768:w-col-6 1200:w-col-4 h-full flex-shrink-0 select-none relative group';
      break;
    case 'SMALL':
      cssString =
        'w-col-6 768:w-col-4 1200:w-col-3 h-full flex-shrink-0 select-none relative group';
      break;
    case 'XSMALL':
      cssString =
        'w-col-4 768:w-col-3 1200:w-col-2 h-full flex-shrink-0 select-none relative group';
      break;
  }

  return <div className={cssString}>{children}</div>;
}
